import { IssuePriority } from '@/entities/issue';
import { DueAfter as DAfter } from '@/entities/issueTemplate';

// The `DueAfter` type is just a copy from `@/entities/issueTemplate::DueAfter`
// but it is not a backend entity (since it will be saved in a JSON).
// Therefore, we won't be creating a `DueAfter` entity in FE.
type DueAfter = DAfter;

type CanBeFilledByInspector<T = Record<string, unknown>> = { definedByInspector: boolean; required: boolean } & T;

export interface IssueTemplateBuilderEditable {
  node_id?: string;
  title: CanBeFilledByInspector<{ value: string | null }>;
  description: CanBeFilledByInspector<{ value: string | null }>;
  assignees: CanBeFilledByInspector<{ value: Array<number | string> }>;
  associateAssignees: CanBeFilledByInspector<{ value: Array<number | string> }>;
  priority: CanBeFilledByInspector<{ value: IssuePriority }>;
  dueIn: CanBeFilledByInspector<{ value: null | DueAfter }>;
  photos: CanBeFilledByInspector;
  entityItemSpecificAssignments: boolean;
  showIssueHasBeenCreated: boolean;
  approvalsEnabled: boolean;
  approvalsEntitySpecificAssignments: boolean;
  approvers: CanBeFilledByInspector<{ value: Array<number | string> }>;
  assignedGroups: CanBeFilledByInspector<{ value: Array<number | string> }>;
}

export const emptyIssueTemplateBuilder = (): IssueTemplateBuilderEditable => ({
  title: {
    definedByInspector: false,
    required: false,
    value: null,
  },
  description: {
    definedByInspector: false,
    required: false,
    value: null,
  },
  assignees: {
    definedByInspector: false,
    required: false,
    value: [],
  },
  associateAssignees: {
    definedByInspector: false,
    required: false,
    value: [],
  },
  priority: {
    definedByInspector: false,
    required: false,
    value: IssuePriority.Normal,
  },
  dueIn: {
    definedByInspector: false,
    required: false,
    value: null,
  },
  photos: {
    definedByInspector: false,
    required: false,
  },
  showIssueHasBeenCreated: false,
  approvalsEnabled: false,
  approvers: {
    definedByInspector: false,
    required: false,
    value: [],
  },
  entityItemSpecificAssignments: false,
  approvalsEntitySpecificAssignments: false,
  assignedGroups: {
    definedByInspector: false,
    required: false,
    value: [],
  },
});
